import React from "react";

import './style.css'

interface Props {
  onHoverText: string;
  altText: string;
  src: string;
  margin?: string;
  linkUrl?: string;
  padding?: string;
  clickAble?: boolean;
  flexGrow?: any;
}

const Icon: React.FC<Props> = ({
  margin,
  flexGrow,
  linkUrl,
  clickAble,
  padding,
  altText,
  src,
  onHoverText
}) => (
  <span className="onhover-icon-container">
    <img
      className="img"
      style={{
        margin,
        flexGrow,
        padding,
        cursor: clickAble ? "pointer" : "",
      }}
      alt={altText}
      src={src}
      onClick={() => clickAble && window.open(linkUrl)}
    />
    {onHoverText && <span className="onhover-icon-text">{onHoverText}</span>}
  </span>
);

export default Icon;
